/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const ReferenceType = {
  CORRECTION: 'correction',
  RELATED: 'related',
} as const;

export type ReferenceType = typeof ReferenceType[keyof typeof ReferenceType];
